import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {Phase} from '../types';
import config from "../config";

export const EditPageNavigation = ({component}: { component: Phase }) => {

    const breadcrumbs = [{
            title: 'Home',
            href: '/dashboard',
        },
        {
            title: 'Playbooks',
            href: `/playbooks`,
        },
        {
            title: component.playbook?.displayName ?? component.playbook?.name ?? component.playbookId,
            href: `/playbooks/${component.playbookId}`,
        },
        {
            title: config.titles.plural,
            href: `/playbooks/${component.playbookId}`,
        },
        {title: component.displayName ?? component.name}].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
